/**
 * ChatGPT Ads (OpenAI) Pixel helper.
 *
 * The configuration script is injected globally in index.html:
 *   <script>…oaiq("init", {pixelId:"6wUv9fxjqJWbn2uBEbcRtg", debug:true})…</script>
 *
 * This module exposes thin wrappers so React components can fire
 * conversion events safely (no-op when the SDK is blocked or unavailable).
 */

declare global {
  interface Window {
    oaiq?: (...args: unknown[]) => void;
  }
}

/** Fire a conversion event on the ChatGPT Ads pixel. */
export function trackOpenAIPixel(
  eventName: string,
  params: Record<string, unknown> = {}
) {
  if (typeof window === "undefined" || !window.oaiq) return;
  try {
    window.oaiq("measure", eventName, params);
  } catch {
    /* ignore pixel errors */
  }
}

/** Shorthand for the standard "registration_completed" conversion. */
export function trackRegistrationCompleted(
  extra: Record<string, unknown> = {}
) {
  trackOpenAIPixel("registration_completed", {
    type: "customer_action",
    amount: 0,
    currency: "USD",
    ...extra,
  });
}
